/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { initialState, UsersState } from '@app/user/store/users.state';
import * as UsersActions from './users.actions';

export function usersReducer(state = initialState, action: UsersActions.UsersActions): UsersState {
  switch (action.type) {
    case UsersActions.LOAD_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        isActionPending: false
      };
    case UsersActions.LOAD_USERS:
      return {
        ...state,
        isActionPending: true
      };
    case UsersActions.LOAD_USER:
    case UsersActions.PERSIST_USER:
      return {
        ...state,
        isActionPending: true,
        persistViolations: []
      };
    case UsersActions.PERSIST_USER_FAILURE:
      return {
        ...state,
        isActionPending: false,
        persistViolations: action.violations
      };
    case UsersActions.LOAD_USER_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        currentUser: action.user
      };
    case UsersActions.PERSIST_USER_SUCCESS:
    case UsersActions.LOAD_USER_FAILURE:
    case UsersActions.LOAD_USERS_FAILURE:
      return {
        ...state,
        isActionPending: false
      };
    default:
      return state;
  }
}
